export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/rating/index.js
// module id = ../../../../ngx-bootstrap/rating/index.js
// module chunks = 7